exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-back-button{position:absolute;top:0;left:0;display:block;width:24px;height:24px;margin:16px;background-color:rgba(0,0,0,0);border:none;border-radius:50%;border:none;overflow:hidden;-webkit-transition:all ease .2s;-o-transition:all ease .2s;transition:all ease .2s;cursor:pointer;z-index:20}@media(min-width: 1160px){.nav-back-button{top:0;left:0;width:48px;height:48px;padding:12px;background-color:#f3f3f3}.nav-back-button:hover{background-color:#f3dddd}}.nav-back-button svg{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/nav-back-button/style.scss
// module id = 1132
// module chunks = 62